// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"142":"d97c1ce97ba790b9","245":"4973e102e9906aec","524":"a7c58aeb9a3a9069","627":"03e48e63122898f0","640":"80400a9188212516"}[chunkId] + ".js";
};